import SearchOverview from "../components/forum/SearchOverview";
import QuestionsList from "../components/forum/QuestionsList";
import LoadingSpinner from "../components/generic/LoadingSpinner";
import BasicPagination from "../components/generic/BasicPagination";
import useQueryParams from "../../common/hooks/useQueryParams.hook";
import { useGetQuestionsQuery } from "../../features/api/questionSlice";

import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import React from "react";

const Search: React.FC = () => {
    /*
        Structure: 
        - SearchOverview (sort, filter)
        - QuestionsList
        - Pagination
    */

    const { queryParams, setQueryParams } = useQueryParams();
    const { data, isSuccess, isFetching } = useGetQuestionsQuery(queryParams);

    if (!isSuccess) {
        return <div></div>;
    }

    const questions = data.results;
    const count = data.count;
    const pageCount = Math.ceil(count / 10);

    return (
        <Box
            component="main"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900],
                flexGrow: 1,
                height: "100vh",
                overflow: "auto",
            }}
        >
            <Toolbar />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>
                    {/* Forum Overview */}
                    <Grid item xs={12}>
                        <SearchOverview
                            queryParams={queryParams}
                            setQueryParams={setQueryParams}
                            questionsCount={count}
                        />
                    </Grid>

                    {/* Questions List */}
                    <Grid item xs={12}>
                        {!isFetching ? <QuestionsList questions={questions} /> : <LoadingSpinner />}
                    </Grid>

                    {/* Pagination */}
                    <Grid item xs={12}>
                        <BasicPagination count={pageCount} isLoading={isFetching} />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Search;
